import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type ConfirmInternalOrganizationMasterServiceAgreementPayloadType = {
  first_name: string;
  middle_name?: string;
  last_name: string;
  agreement_id: string;
};

export const confirmInternalOrganizationMasterServiceAgreementApi = (
  payload: ConfirmInternalOrganizationMasterServiceAgreementPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/organization/internal/master-service-agreement/confirmation/';

  return authApiService.POST(uri, payload);
};
